import * as yup from 'yup';

export const myStoreSchema = yup.object().shape({
  name: yup
    .string()
    .required('Este campo é obrigatório.')
    .min(2, 'O nome da loja precisa ter pelo menos 2 caracteres.')
    .max(1000, 'O nome da loja pode ter até 1000 caracteres.'),
});
